import axios from "axios";
import { API_URL, EP_URL, PAYMENT_API_URL } from "./index";

// eslint-disable-next-line
export default {
  GetTokenForPayment() {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_ENDPOINT_PAYMENT_GET_TOKEN || process.env.REACT_APP_ENDPOINT_GET_TOKEN}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: process.env.REACT_APP_EP_API_KEY,
        secret: process.env.REACT_APP_EP_API_SECRET,
      },
    });
  },

  GetEPToken() {
    return axios({
      method: "post",
      url: `${EP_URL}${process.env.REACT_APP_ENDPOINT_EP_GET_TOKEN}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        key: "1k8FbYJ1j5q7DkzcQ5Vj",
        secret: "hZvYnUiPZHnc14tJLLAL",
      },
    });
  },

  GetPoiDetails(token, poiID) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_POI_DETAILS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        poiID: poiID
      },
    });
  },

  GetMall(token, mallID) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_MALL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        mallID: mallID
      },
    });
  },

  SendSms(token, phone, message, lang) {
    const data = {
      phone: phone,
      message: message,
      ...(lang === "tr" ? { lang: "tr" } : {}),
    };
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_SEND_SMS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  SendOTPEmail(token, email, otp, lang) {
    const data = {
      email,
      otp,
      ...(lang === "tr" ? { lang: "tr" } : {}),
    };
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_SEND_OTP_EMAIL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data,
    });
  },

  GetOTPViaEmail(email, lang) {
    const data = {
      email,
      ...(lang === "tr" ? { lang: "tr" } : {}),
    };
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_OTP_VIA_EMAIL}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    });
  },

  GetOTPViaPhone(phone, lang) {
    const data = {
      phone,
      ...(lang === "tr" ? { lang: "tr" } : {}),
    };
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_OTP_VIA_PHONE}`,
      headers: {
        "Content-Type": "application/json",
      },
      data,
    });
  },

  CheckOTPViaEmail(email, otp) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CHECK_OTP_VIA_EMAIL}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        email,
        otp,
      },
    });
  },

  CheckOTPViaPhone(phone, otp) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CHECK_OTP_VIA_PHONE}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        phone,
        otp,
      },
    });
  },

  GetCustomerByPhone(token, phone) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_CUSTOMER_BY_PHONE}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        phone: phone
      },
    });
  },

  GetCustomerByEmail(token, email) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_CUSTOMER_BY_EMAIL}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        email: email
      },
    });
  },

  CreateUser(token, name, lastname, email, phone, identityNo, password) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CREATE_USER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        name,
        lastname,
        email,
        phone,
        identityNo,
        password
      },
    });
  },

  GetVehiclePrices(token, type, mallID) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_VEHICLE_PRICES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        type: type,
        mallID: mallID
      },
    });
  },
  CreateOrder(token, poiID, customerID, type, willDeliverDateTime, price, currency, billing, durationText, duration, usedCoupon, confirmedAgreementText = null, confirmedAgreementIP = null, paymentType) {
    let durationString = "";
    if (durationText === "1 Gün") {
      durationString = durationText;
    } else if (durationText === "30 DK") {
      durationString = "30 Dakika";
    } else {
      durationString = durationText ? durationText + " saat" : "";
    }

    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CREATE_ORDER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        poiID,
        customerID,
        type,
        willDeliverDateTime,
        price,
        currency,
        billing,
        durationText: durationString,
        duration,
        usedCoupon,
        confirmedAgreementText, 
        confirmedAgreementIP,
        paymentType,
      },
    });
  },

  ExtendOrderDeliverTime(token, requestID, extendedSeconds, price, currency) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_EXTEND_ORDER_DELIVER_TIME}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        requestID,
        extendedSeconds,
        price,
        currency
      },
    });
  },

  CreateOrderForGift(token, poiID, customerID, type, packageCount, price, currency, billing, usedCoupon, paymentType) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_CREATE_ORDER}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        poiID,
        customerID,
        type,
        packageCount,
        price,
        currency,
        billing,
        usedCoupon,
        paymentType,
      },
    });
  },

  PaymentWith3D(conversationID, price, name, lastname, phone, holderName, cardNumber, expYear, expMonth, cvc) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_ENDPOINT_PAYMENT_WITH_3D}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        id: '579224568643984170160192132079',
        conversationID: conversationID,
        totalPrice: price,
        paidPrice: price,
        discount: 0,
        installment: 1,
        currency: "TRY",
        customer: {
          name: name,
          lastname: lastname,
          phone: phone
        },
        creditCardInfos: {
          holderName: holderName,
          cardNumber: cardNumber,
          expYear: expYear,
          expMonth: expMonth,
          cvc: cvc
        },
        willBeStored: false,
        cardAlias: false,
        items: [
          {
            name: "Emanet Kiralama",
            price: price
          }
        ],
        callback: false
      },
    });
  },

  ListenPayment(conversationID) {
    const token = localStorage.getItem("token");
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_ENDPOINT_LISTEN_PAYMENT}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        conversationID,
        id: '579224568643984170160192132079',
      },
    });
  },

  GetPaymentError(conversationID) {
    return axios({
      method: "post",
      url: `${PAYMENT_API_URL}${process.env.REACT_APP_ENDPOINT_GET_PAYMENT_ERROR}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        conversationID,
        id: '579224568643984170160192132079',
      },
    });
  },

  SetPaid(requestID, paymentID, last4Digit) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_SET_PAID}`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        requestID: requestID,
        paymentID: paymentID,
        creditCardLast4Digit: last4Digit,
      },
    });
  },

  GetMyOrders(token, customerID, poiID) {
    return axios({
      method: "post",
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_MY_ORDERS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: {
        customerID: customerID,
        poiID: poiID,
      },
    });
  },

  GetCities(token) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_CITIES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });
  },
  GetTowns(token, cityCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_TOWNS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        cityCode: cityCode,
      },
    });
  },
  GetRegions(token, townCode) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_REGIONS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        townCode: townCode,
      },
    });
  },
  ValidateCoupon(token, couponCode, discountForProduct) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_VALIDATE_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        couponCode,
        discountForProduct,
      },
    });
  },
  UseCoupon(token, couponCode, discountForProduct, userID, name, lastname, mallTitle, requestID, transactionAmount, netAmount) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_USE_COUPON}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        couponCode,
        discountForProduct,
        userID,
        usedByInfo : {
          name: name,
          lastname: lastname,
          mallTitle: mallTitle,
          requestID: requestID,
          transactionAmount: transactionAmount,
          netAmount: netAmount
        },
      },
    });
  },

  InvoiceAdd(token, customer, billing, order,confirmedAgreementTextArray,confirmedAgreementIP) {
    return axios({
      method: 'post',
      url: `${EP_URL}${process.env.REACT_APP_ENDPOINT_INVOICE_ADD}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        customer,
        billing,
        order,
        confirmedAgreementTextArray,
        confirmedAgreementIP
      },
    });
  },

  AddUserBillingAddress(token, id, uID, title, street, neighbour, region, city, country, phone, address, taxNo, email, taxAdministration) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_ADD_USER_BILLING_ADDRESS}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        id,
        uID,
        title,
        street,
        neighbour,
        region,
        city,
        country,
        phone,
        address,
        taxNo,
        email,
        taxAdministration
      },
    });
  },

  GetUsersBillingAddresses(token, userID) {
    return axios({
      method: 'post',
      url: `${API_URL}${process.env.REACT_APP_ENDPOINT_GET_USERS_BILLING_ADDRESSES}`,
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      data: {
        userID
      },
    });
  },
};
